import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './shared/interceptor/loading.interceptor';
import { ToastInterceptor } from './shared/interceptor/toast.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { ToastrModule } from 'ngx-toastr';

import { QuillModule } from 'ngx-quill';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoadingComponent } from './components/loading/loading.component';

import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotPwdComponent } from './forgot-pwd/forgot-pwd.component';

import { MainComponent } from './layouts/main/main.component';
import { TopHeaderComponent } from './layouts/top-header/top-header.component'
import { FooterComponent } from './layouts/footer/footer.component';
import { NavbarComponent } from './layouts/navbar/navbar.component';

import { ErrorComponent } from './layouts/error/error.component';
import { ForbiddenComponent } from './layouts/forbidden/forbidden.component';

import { SharedModule } from './shared/shared.module';

import { AuthInterceptor } from './shared/interceptor/auth.interceptor';

import { LoginService } from './services/login.service';
import { UserService } from './services/user.service';
import { DagService } from './services/dag.service';
import { ListService } from './services/list.service';
import { DataService } from './services/data.service';
import { ProjectService } from './services/project.service';

// import { MustMatchDirective } from './shared/directives/must-match.directive';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// import { ChartDirective } from './chart.directive'; // Adjust the path if needed
import { CreateProjectComponent } from "src/app/components/create-project/create-project.component";
import { NgSelectModule } from '@ng-select/ng-select';
import { AdminGuard } from './shared/auth/admin.guard';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { LowercaseInputDirective } from './shared/directives/lowercase-input.directive';
import { ProfileModalComponent } from './components/profile-modal/profile-modal.component';
@NgModule({
	declarations: [
		AppComponent,
		LoadingComponent,
		MainComponent,
		TopHeaderComponent,
		FooterComponent,
		NavbarComponent,
		ErrorComponent,
		ForbiddenComponent,
		LoginComponent,
		SignupComponent,
		ForgotPwdComponent,
		
		// ChartDirective
		// MustMatchDirective	
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		ReactiveFormsModule,
		FormsModule,
		AppRoutingModule,
		SharedModule,
		NgbModule,
		NgSelectModule,
		QuillModule.forRoot(),
		ToastrModule.forRoot({
			timeOut: 5000,
			positionClass: 'toast-top-right',
			preventDuplicates: true,
			closeButton: true,
			progressBar: true
		}),
		CreateProjectComponent,
		MonacoEditorModule.forRoot() ,
		LowercaseInputDirective,
		ProfileModalComponent
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LoadingInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ToastInterceptor,
			multi: true
		},
		LoginService,
		UserService,
		DagService,
		ListService,
		DataService,
		ProjectService,
		AdminGuard,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	bootstrap: [AppComponent],
	// exports: [ChartDirective]
})

export class AppModule { }
